import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@/components";

interface NeedsAnalysisStepBodyProps {
	description: string;
}

export default function NeedsAnalysisStepBody({ description }: NeedsAnalysisStepBodyProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`questionnaire.needs-analysis.progress.${key}`);
	const [expanded, setExpanded] = useState(false);
	const lines = description.split("\n");
	const isLong = lines.length > 5;
	const displayedText = isLong && !expanded ? lines.slice(0, 5).join("\n") : description;

	return (
		<div>
			<div
				dangerouslySetInnerHTML={{ __html: displayedText }}
				className="text-[14px] p-6 pt-0 leading-5 text-primary-gray-lighter prose prose-ul:pl-5 prose-ol:pl-5"
			/>
			{isLong && (
				<button
					className="text-primary-blue mt-2"
					type="button"
					onClick={() => setExpanded(!expanded)}
				>
					{expanded ? (
						<p className="flex gap-2 text-[14px] font-medium items-center text-primary-blue">
							{ts("readLess")}
							<Icon className="w-3 h-3" icon={faChevronUp} />
						</p>
					) : (
						<p className="flex gap-2 text-[14px] font-medium items-center text-primary-blue">
							{ts("readMore")}
							<Icon className="w-3 h-3 text-primary-blue" icon={faChevronDown} />
						</p>
					)}
				</button>
			)}
		</div>
	);
}
